import { faRotate, faTrash, faWrench } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip } from '@mui/material';

import DeviceStatusChip from '@/components/DeviceStatusChip';

import { DEVICE_TYPE_LIMA } from '../DevicesTable.deviceTypes';
import useStyles from '../DevicesTable.styles';
import type { AdminDeviceStatusCellRendererProps } from './AdminDeviceStatusCellRenderer.types';

/**
 * Cell renderer for device status column in admin devices view
 *
 * Displays device status chip with optional action indicators:
 * - Wrench icon for updated devices
 * - Trash icon for deleted devices
 * - Rotating icon for sync in progress
 *
 * Shows last updated time in tooltip. Skips rendering for group rows.
 *
 * @param props - AG Grid cell renderer params with optional isMainDevicePage flag
 * @returns JSX element with status chip and action icons
 */
const AdminDeviceStatusCellRenderer = (
  props: AdminDeviceStatusCellRendererProps
) => {
  const { classes } = useStyles();
  const { data, isMainDevicePage } = props;

  if (!data || data.isGroupRow) {
    return null;
  }

  return (
    <Tooltip
      arrow
      placement="left"
      title={`Last updated ${data.status_updated_at_display || ''}`}
      classes={{
        arrow: classes.routeButtonTooltipArrow,
        tooltip: classes.routeButtonTooltip
      }}
    >
      <Box style={{ whiteSpace: 'nowrap' }}>
        <DeviceStatusChip status={data.status || ''} />

        {isMainDevicePage &&
          !data.isSyncInProgress &&
          data.device_type_id !== DEVICE_TYPE_LIMA && (
            <>
              {data.actionType === 'Updated' && (
                <FontAwesomeIcon
                  icon={faWrench}
                  size="sm"
                  style={{ marginLeft: '.5rem' }}
                />
              )}
              {data.actionType === 'Deleted' && (
                <FontAwesomeIcon
                  icon={faTrash}
                  size="sm"
                  style={{ marginLeft: '.5rem' }}
                />
              )}
            </>
          )}

        {isMainDevicePage &&
          data.isSyncInProgress &&
          data.device_type_id !== DEVICE_TYPE_LIMA && (
            <FontAwesomeIcon
              style={{ marginLeft: '.5rem' }}
              icon={faRotate}
              size="sm"
              className={classes.warningColor}
            />
          )}
      </Box>
    </Tooltip>
  );
};

export default AdminDeviceStatusCellRenderer;
